import classNames from 'classnames';
import { ReactElement, useEffect, useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';

import Loader from '~/ui/components/common/Loader';
import AddNote from './components/AddNote';
import AIAssistedNote from './components/AIAssistedNote';
import AISettings from './components/AISettings';
import { IAiAssistForm } from './types';

import useFeature from '~/store/clinic/hooks/useFeature';
import { useStoreState } from '~/store/hooks';
import { REPORTS } from '~/ui/constants/paths';
import useClinic from '../Clinics/hooks/useClinic';

import styles from './AiAssist.module.scss';

const AiAssist = (): ReactElement => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const form = useForm<IAiAssistForm>({
    defaultValues: {
      note: '',
      assistedNote: '',
      originalNote: '',
    },
  });

  useClinic();

  const { isAiAssistAvailable } = useFeature();
  const clinic = useStoreState(state => state.clinic.current);

  useEffect(() => {
    if (!isAiAssistAvailable && clinic) {
      navigate(REPORTS);
    }
  }, [isAiAssistAvailable, clinic, navigate]);

  if (!isAiAssistAvailable) {
    return null;
  }

  return (
    <FormProvider {...form}>
      <h2 className={styles.title}>Ai Assist</h2>

      {loading && <Loader className={styles.loader} />}

      <main className={classNames(styles.container, { [styles.loading]: loading })}>
        <AddNote setLoading={setLoading} loading={loading} />
        <AISettings />
        <AIAssistedNote setLoading={setLoading} loading={loading} />
      </main>
    </FormProvider>
  );
};

export default AiAssist;
